const keys = {
    API_BASE: process.env.REACT_APP_CDM_API || '/api',
    CAS_CALLBACK: process.env.REACT_APP_PROXY_AUTH_CALLBACK_URL,
    CAS_ENDPOINT: process.env.REACT_APP_CAS_ENDPOINT,
    ENV: process.env.NODE_ENV,
    ENVIRONMENT: process.env.ENV,
};

export default keys;
